// MUI Components
import {
  Box,
  Typography,
  Modal,
  Button
} from '@mui/material';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function GameDialog({ open, title, message, onConfirm, onCancel }) {
  const { theme } = useTheme();

  return (
    <Modal open={open} onClose={onCancel}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 340,
        bgcolor: theme.background.primary,
        border: `2px solid ${theme.border.medium}`,
        boxShadow: 24,
        borderRadius: 3,
        p: 3,
        textAlign: 'center',
      }}>
        <Typography variant="h6" color={theme.color.primary} fontWeight={700} mb={2} fontFamily={theme.fontFamily}>
          {title}
        </Typography>
        <Typography variant="body1" color={theme.text.primary} mb={3} fontFamily={theme.fontFamily}>
          {message}
        </Typography>
        <Box display="flex" justifyContent="center" gap={2}>
          <Button variant="contained" color="error" onClick={onConfirm} sx={{ fontFamily: theme.fontFamily }}>
            Yes, Close
          </Button>
          <Button variant="outlined" color="primary" onClick={onCancel} sx={{ fontFamily: theme.fontFamily }}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
